import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import * as actions from '@appStore/contracts/actions';
import { ActionTypes, AgreementLinkLoad } from '@appStore/contracts/actions';
import { ServiceAgreementService } from '@appStore/contracts/services';


@Injectable()
export class ServiceAgreementsEffects{
    constructor(private serviceAgreementService: ServiceAgreementService, private actions$: Actions){}

    getMyServiceAgreements$ = createEffect(() =>{
        return this.actions$.pipe(
          ofType(ActionTypes.ServiceAgreementsLoad),
          exhaustMap((action: actions.ServiceAgreementsLoad) => {
            return this.serviceAgreementService.getMyServiceAgreement().pipe(
              map(item => new actions.ServiceAgreementsLoadSuccess(item)),
              catchError(error => of(new actions.ServiceAgreementsLoadFail(error)))
            );
          })
        );
    });
}